import React from "react";
import { columns, categories } from "./config";
import _ from "lodash";

export const initialState = {
    list: [],
    columns: columns,
    categories: categories,
    searchedIndex: 0,
    searchedQuery: "",
    counter: "",
    filters: {},
    sorting: {order: "desc", column: "dueDate"},
    showCompletedTasks: false,
    prefilters: {
        workstream: null,
        assignee: null
    }
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case "UPDATE_T_TASKLIST_COLUMNS": 
            return { 
                ...state, 
                columns: action.columns
            };
        
        case "CLEAR_T_TASKLIST_COLUMNS":
            return {
                ...state,
                columns: initialState.columns
            }
        
        case "UPDATE_T_TASKLIST_CATEGORIES": 
            return {
                ...state,
                categories: action.categories
            }

        case "SET_T_TASKLIST_LIST": 
            return {
                ...state,
                list: action.list
            }

        case "UPDATE_T_TASKLIST_LIST": {
            let list = state.list;

            for(const item of action.list) {
                const updateIndex = _.findIndex(list, { id: item.id });

                if(updateIndex >= 0) {
                    list.splice(updateIndex, 1, {...list[updateIndex], ...item});
                } else {
                    list.push({...item, ref: React.createRef()});
                }
            }

            return {
                ...state,
                list: list
            }
        }

        case "DELETE_T_TASKLIST_ITEM": {
            let list = state.list;

            const updatedList = _.remove(list, listObj => {
                return listObj.id !== action.id;
            });

            return { 
                ...state, 
                list: updatedList 
            };
        }
        
        case "CLEAR_T_TASKLIST_LIST":
            return {
                ...state,
                list: []
            }

        case "UPDATE_T_TASKLIST_SEARCHED_INDEX": 
            return {
                ...state,
                searchedIndex: action.index
            }

        case "UPDATE_T_TASKLIST_SEARCHED_QUERY": 
            return {
                ...state,
                searchedQuery: action.query
            }
        

        case "SET_T_TASKLIST_SORTING":
            return {
                ...state,
                sorting: action.sorting
            }

        case "SET_T_TASKLIST_FILTERS":
            return {
                ...state,
                filters: {
                    ...state.filters,
                    [action.column]: action.filters
                }
            }
        
        case "SET_T_TASKLIST_COUNTER":
            return {
                ...state,
                counter: action.counter
            }
        
        case "SET_T_TASKLIST_SHOW_COMPLETED":
            return {
                ...state,
                showCompletedTasks: action.boolean
            }

        case "SET_T_TASKLIST_PREFILTERS": {
            return {
                ...state,
                prefilters: {
                    ...state.prefilters,
                    [action.column]: action.filter
                }
            }
        }
        
        case "ClEAR_T_TASKLIST_COLUMN_FILTERS": 
            return {
                ...state,
                filters: {
                    ...state.filters,
                    [action.column]: (state.filters[action.column] || []).map(f => ({...f, isActive: true}))
                }
            }
        
        case "CLEAR_T_TASKLIST_COLUMNS": 
            return {
                ...state,
                columns: initialState.columns
            }
        
        case "CLEAR_T_TASKLIST_FILTERS": 
            return {
                ...state,
                columns: initialState.columns,
                sorting: initialState.sorting
            }

        case "CLEAR_TASKS_DATA":
            return initialState;

        default:
            return state;
    }
}
